module.exports = __webpack_public_path__ + "img/xbk1.3772c0b7.png";